import axios, { AxiosRequestConfig } from 'axios';

import { IPostgreJobsAnalyticsPayload } from '..';

const url = '/invoicingservice/api/potential-revenue/composable-analytics';

export const fetchPotentialRevenueAnalyticsWidgetData = (
  query: IPostgreJobsAnalyticsPayload,
  config: AxiosRequestConfig
) => axios.post(`${url}/${query.type}`, query, config);
